import React from "react";
import {
  Button,
  Modal,
  Modal as modal,
  Space as space,
  Button as button,
} from "antd";
import { Form } from "@ant-design/compatible";
import { useState } from "react";
import "../CreateTicket.css";
import CloseIcon from "../../../images/GroupAdmincloseIcon.svg";

function AddAttachment({
  isUpdateModel,
  activeKey,
  remove,
  handleOk,
  handleCancel,
  ticketData,
  setTicketData,
}) {
  const [fileError, setFileError] = useState(false);
  const [fileformatMismatch, setFileFormatMismatch] = useState(false);
  const [filesizeExceeded, setFileSizeExceeded] = useState(false);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    const allowedFormats = [
      ".pdf",
      ".docx",
      ".xls",
      ".csv",
      ".txt",
      ".jpg",
      ".jpeg",
      ".png",
    ];
    const maxFileSize = 25 * 1024 * 1024;

    // Check if file format is allowed
    const fileExtension = file?.name
      .slice(file?.name.lastIndexOf("."))
      .toLowerCase();
    if (!allowedFormats.includes(fileExtension)) {
      setFileError(true);
      setFileFormatMismatch(true);
      return;
    }

    // Check if file size is within the allowed limit
    if (file.size > maxFileSize) {
      setFileError(true);
      setFileSizeExceeded(true);
      return;
    } else {
      setFileError(false);
      setFileFormatMismatch(false);
      setFileSizeExceeded(false);
      setTicketData({
        ...ticketData,
        Files: [...ticketData.Files, file],
      });
    }
  };

  const handleAttachmentDelete = (index) => {
    const newFiles = [...ticketData.Files];
    newFiles.splice(index, 1);
    setTicketData({ ...ticketData, Files: newFiles });
    setFileError(false);
    setFileFormatMismatch(false);
    setFileSizeExceeded(false);
  };

  const cancelButton = () => {
    remove(activeKey);
  };

  const warning = () => {
    modal.confirm({
      title: "Are you sure to cancel",
      content: "cancel will discard all the added data",
      onOk() {
        cancelButton();
      },
      okText: "Yes, Cancel",
      cancelText: "No",
    });
  };

  return (
    <>
      <>
        <Modal
          title={[
            <b>Add Attachment</b>,
            <button
              style={{
                backgroundColor: "transparent",
                border: "none",
                float: "right",
              }}
              onClick={handleCancel}
            >
              <img
                src={CloseIcon}
                style={{
                  width: "1em",
                  height: "1em",
                  marginLeft: "95px",
                }}
              />
            </button>,
          ]}
          open={true}
          closable={false}
          style={{ fontFamily: "Montserrat", width: "40vw" }}
          className="modalForAuth"
          footer={[
            <button
              className="btn btn-primary AuthCancelButton ml-2"
              style={{
                float: "left",
              }}
              onClick={handleCancel}
            >
              Cancel
            </button>,
            <button
              className="btn btn-primary AuthSubmitButton mr-2"
              onClick={handleOk}
            >
              {!isUpdateModel ? "Add" : "Update"}
            </button>,
          ]}
        >
          <div>
            <div
              className="form-text-decorator ml-1 mt-3"
              style={{ fontWeight: "600", fontSize: "12px" }}
            >
              Attachment Upload
            </div>
            <Form.Item>
              <div>
                {ticketData.Files.length < 5 && (
                  <>
                    <label
                      className={`uploadLabel ${fileError ? "fileError" : ""}`}
                      for="upload-photo"
                    >
                      <input
                        size="small"
                        type="file"
                        name="photo"
                        id="upload-photo"
                        onChange={handleFileUpload}
                        accept=".pdf,.docx,.xls,.csv,.txt,.jpg,.jpeg,.png,.zip"
                      />
                      <span className="fileName">Add Attachment</span>
                    </label>
                  </>
                )}
                {ticketData.Files.map((file, index) => {
                  return (
                    <div className="afterUploadAttachmentDiv">
                      <div key={index} className="afterUploadAttachemntColor">
                        {file.name}
                      </div>
                      <div
                        className="attachmentClose"
                        onClick={() => handleAttachmentDelete(index)}
                      >
                        <img
                          src={CloseIcon}
                          className="attachmentCloseButton"
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </Form.Item>
          </div>
          <div className="customErrorText mx-2 pt-2">
            {filesizeExceeded && (
              <div>
                Attached document exceeds allowed limit.<br></br>
                File size should be below or equal to 25MB.
              </div>
            )}
            {fileformatMismatch && (
              <div>
                File format not supported.<br></br>
                Please attach any file with .PDF, .DOCX, .XLS, .CSV, .TXT, .JPG,
                .JPEG, .PNG extension only
              </div>
            )}
          </div>
        </Modal>
      </>
    </>
  );
}

export default Form.create({ name: "AddAttachment" })(AddAttachment);
